import $ from 'jquery';
import empty from './empty';

function replaceUrl (url, title, replace, useState, setHash, preview) {
    'use strict';

    let hashUrl = url;

    if (preview) {
        hashUrl = hashUrl.replace(/[?|&]preview=(\d+)/, '');
    }

    if (useState) {
        if (replace) {
            window.history.replaceState({state: title}, '', url);
            $(window).trigger('hashchange', {url: hashUrl});
        } else {
            window.history.pushState({state: title}, '', url);
            $(window).trigger('hashchange', {url: hashUrl});
        }
    } else {
        window.location.hash = url;

        $(window).trigger('hashchange', {
            url: hashUrl,
            replace: replace,
            setHash: setHash,
            useState: useState
        });
    }
}

/**
 * Window URL Changer
 * @param hash
 * @param {Boolean} replace
 * @param {Boolean} setHash
 */
export default function (hash, replace, setHash) {
    'use strict';

    // Get the anchor that was clicked
    let pageUrl = hash;

    if (pageUrl.length > 0) {
        pageUrl = pageUrl.toLowerCase().replace(/[?|&]preview=(\d+)/, '');
    }

    let path = window.location.pathname.replace(/^\//, '').split('/').reverse();
    let current = '';

    if (setHash) {
        current = window.location.hash.replace('#', '');
    } else if (path.length > 1) {
        current = path.shift();
    }

    let query = window.location.search;

    const preview = (query.indexOf('preview=') > -1);
    const $currentChapter = $('.js-chapter.is-current');
    let chapterUrl = '';

    if (setHash && $currentChapter !== undefined && $currentChapter.length) {
        const firstChapterId = $currentChapter.attr('id');
        if (path.indexOf(firstChapterId) < 0) {
            chapterUrl = firstChapterId;
        }
    }

    // Update the browser URL
    if (pageUrl !== current) {
        if (pageUrl.length > 0) {
            if (!empty(query) && setHash) {
                pageUrl = query + '#' + pageUrl;
            } else if (!empty(query) && !setHash) {
                pageUrl += query;
            }

            if (pageUrl.indexOf('#') === -1 && setHash) {
                pageUrl = '#' + pageUrl;
            } else if (!setHash) {
                pageUrl = '/' + pageUrl;
            }

            //set the first chapter url while scrolling on cover page
            if (chapterUrl) {
                pageUrl = ('/' + path.reverse().join('/')).replace(/\/$/, "") + '/' + chapterUrl;
            } else {
                pageUrl = '/' + path.reverse().join('/') + pageUrl;
            }
        } else {
            pageUrl = window.location.pathname;
            if (chapterUrl) {
                pageUrl = pageUrl.replace(/\/$/, "") + '/' + chapterUrl;
            }
        }

        replaceUrl(pageUrl, document.title, replace, history.pushState && history.replaceState, setHash, preview);
    }
}
